module.exports = __webpack_public_path__ + "img/rainy-1.f134a51c.svg";